import React, { Fragment, useState, useEffect } from 'react';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
    Box,
    Grid
} from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const RadioInput = ({ questionnaireData }) => {
    return (
        <MainCard
            title={
                questionnaireData.questionNumber
                    ? `Questão ${questionnaireData.questionNumber}`
                    : null
            }
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                    {questionnaireData.value}
                </Typography>
                <RadioGroup>
                    {questionnaireData.options.map((option, i) => (
                        <FormControlLabel
                            key={i}
                            value={option.value}
                            control={
                                <Radio
                                    checked={option.value === questionnaireData.answer}
                                    disabled
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </MainCard>
    );
};

RadioInput.propTypes = {
    questionnaireData: PropTypes.shape({
        id: PropTypes.any.isRequired,
        questionNumber: PropTypes.number,
        value: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired
            }).isRequired
        ).isRequired
    }).isRequired,
    onInputChange: PropTypes.func.isRequired
};

export default RadioInput;
